import * as React from "react";
import * as Rest from "../../Generated/RestClient";
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";

export interface BotOpenComposerProps extends React.Props<BotOpenComposer>{
    downloadUrl: string;
    payload: SimpleMvc.QueryParams;
}

export interface BotOpenComposerState {
    bot: Rest.BotService;
    blocked?: boolean;
}

export class BotOpenComposer extends React.Component<BotOpenComposerProps, BotOpenComposerState> {

    private get bot() : Rest.BotService {
        return this.state && this.state.bot;
    }

    constructor(props: BotOpenComposerProps) {
        super(props);
    }

    private getBotId(s: BotOpenComposerState) : string {
        return s && s.bot ? s.bot.Id : null;
    }

    private openInComposer() {
        const allTags = JSON.parse(this.bot.AzureTags || "{}");
        const tags = Object.keys(allTags)
            .filter(x => x === 'webapp' || x === 'function')
            .reduce((cur, tagName) =>
                ({...cur, [tagName]: allTags[tagName]}),
                {});
        const tagCount = Object.keys(tags).length;
        const payload = {
            ...this.props.payload,
            botId: this.bot.Id,
            botName: this.bot.Name,
            appId: this.bot.MsaAppId,
            appPasswordHint: this.bot.AppPasswordHint,
            resourceId: `/subscriptions/${this.bot.SubscriptionId}/resourceGroups/${this.bot.ResourceGroupName}/providers/Microsoft.BotService/botServices/${this.bot.Id}`,
            tags: tagCount > 0 ? tags : undefined
        }
        const t = window.open(`bfcomposer://import?source=abs&payload=${encodeURIComponent(JSON.stringify(payload))}`);
        return t;
    }

    public componentDidUpdate(prevProps: BotOpenComposerProps, prevState: BotOpenComposerState) {
        const prevBotId = this.getBotId(prevState);
        const curBotId =this.getBotId(this.state);

        if (curBotId && curBotId !== prevBotId && this.bot.OpenWithHint === 'bfcomposer://') {
            const t = this.openInComposer();
            if (!t || t.closed || typeof t.closed === 'undefined') {
                this.setState({blocked: true});
            }
        }
    }

    private renderOpenButton() : JSX.Element {
        if (this.state && this.state.blocked) {
            return (
            <button
                style={{
                    marginRight: '2ch'
                }}
                onClick={() => this.openInComposer()}>
                {Resources.openInComposer}
            </button>);
        }
        return null;
    }

    public render() : JSX.Element {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'baseline',
                padding: '4ch',
                justifyContent: 'center',
                flexWarp: 'wrap'

            }}>
                {this.renderOpenButton()}
                <p>
                    <a href={this.props.downloadUrl}>{Resources.downloadComposer}</a>
                </p>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotOpenComposer.tsx